import { render, staticRenderFns } from "./SearchBrowse.vue?vue&type=template&id=efe5f588&scoped=true"
import script from "./SearchBrowse.vue?vue&type=script&lang=ts"
export * from "./SearchBrowse.vue?vue&type=script&lang=ts"
import style0 from "./SearchBrowse.vue?vue&type=style&index=0&id=efe5f588&prod&lang=css"
import style1 from "./SearchBrowse.vue?vue&type=style&index=1&id=efe5f588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe5f588",
  null
  
)

export default component.exports